import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  UnshareFolderEntriesInput,
  UnshareFolderEntriesMutation,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const UNSHARE_FOLDER_ENTRIES_MUTATION = graphql(`
  mutation UnshareFolderEntries($input: UnshareFolderEntriesInput!) {
    unshareFolderEntries(input: $input) {
      id
    }
  }
`);

const useUnshareFolderEntries = (
  projectId: string,
  options?: UseMutationOptions<
    UnshareFolderEntriesMutation,
    unknown,
    UnshareFolderEntriesInput
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(UNSHARE_FOLDER_ENTRIES_MUTATION, { input });
    },
    ...options,
    onSuccess: async (...args) => {
      await options?.onSuccess?.(...args);
      console.debug('invalidating queries after unsharing folder entries');
      await queryClient.invalidateQueries({
        queryKey: projectKeys.folderEntries(projectId),
      });
    },
  });
};

export default useUnshareFolderEntries;
